import { useCallback } from 'react'

import { api } from 'app/api'
import { PUT_EDIT_COMPLEX, convertParams } from 'app/common/api/requests/food/schools/complexes/put'
import { DietFoodTypeId } from 'app/dataTypes/org/dietFoodTypes'

type ComplexData = {
  // TODO
  // photo
  // fixed_price_enabled
  // fixed_price
  // title
  buffetZone: boolean
  hotMealsZone: boolean
  denyParentMoneySales: boolean
  denyMoreThanOneSales: boolean
  disableForTerminalGuestSales: boolean
  useAsAdditional: boolean
  fundMovementTypeCode?: number | null
  buildingId?: number
  dietFoodTypeId?: DietFoodTypeId
}

type Options = {
  orgID: string
  complexID: string
}

export default function useComplexActions({ orgID, complexID }: Options) {
  const submit = useCallback(
    async ({
      buffetZone,
      hotMealsZone,
      denyParentMoneySales,
      denyMoreThanOneSales,
      disableForTerminalGuestSales,
      useAsAdditional,
      fundMovementTypeCode,
      buildingId,
      dietFoodTypeId,
    }: ComplexData) => {
      const res = await api.request(PUT_EDIT_COMPLEX, {
        error: 'Не удалось сохранить данные комплекта',
        params: {
          orgId: orgID,
          complexId: complexID,
          // TODO
          // photo
          // fixed_price_enabled
          // fixed_price
          // title
          buffetZone,
          hotMealsZone,
          denyParentMoneySales,
          denyMoreThanOneSales,
          disableForTerminalGuestSales,
          useAsAdditional,
          fundMovementTypeCode,
          buildingId,
          dietFoodTypeId,
        },
        convertions: {
          convertParams,
        },
      })

      if (res) {
        return true
      }
      return false
    },
    [orgID, complexID],
  )

  return { submit }
}
